import { formatDate } from '@/lib/date';
import type { ConsentTimeline } from '@/types/candidates';
import { consentExpiryTone } from '../lib/consent-expiry';

const DEFAULT_POLICY = 'v1.0';

interface CandidateGdprRetentionCardProps {
  timeline: ConsentTimeline;
}

export function CandidateGdprRetentionCard({ timeline }: CandidateGdprRetentionCardProps) {
  // HW-1023: the end day comes from the backend — the day the nightly job
  // expires the consent on (grant day + 1 calendar year, UTC) — instead of a
  // 12 × 30-day estimate made here.
  const expiry = timeline.consentExpiry;

  return (
    <section className="space-y-2 rounded-lg border border-border bg-background p-4 text-xs">
      <h3 className="text-sm font-medium text-foreground">Retention</h3>
      <dl className="space-y-1.5 text-muted-foreground">
        <div className="flex justify-between gap-2">
          <dt>Retention period</dt>
          <dd className="text-foreground">1 year</dd>
        </div>
        <div className="flex justify-between gap-2">
          <dt>Active policy</dt>
          <dd className="text-foreground">{timeline.policyVersion ?? DEFAULT_POLICY}</dd>
        </div>
        <div className="flex justify-between gap-2">
          <dt>{expiry?.state === 'EXPIRED' ? 'Consent ended' : 'Consent ends'}</dt>
          <dd
            className={
              expiry && expiry.state !== 'ACTIVE' ? consentExpiryTone(expiry) : 'text-foreground'
            }
          >
            {expiry?.endsOn ? formatDate(expiry.endsOn, 'short') : '—'}
          </dd>
        </div>
      </dl>
      <p className="pt-1 text-[11px] text-muted-foreground">
        Central GDPR settings will ship at <span className="font-mono">/settings/recruitment/gdpr</span>.
      </p>
    </section>
  );
}
